"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6272 9.0735A3.4852 3.4852 0 0 0 11 7.5C11 5.567 9.433 4 7.5 4S4 5.567 4 7.5 5.567 11 7.5 11a3.4852 3.4852 0 0 0 1.5697-.3709L10.3684 12l-1.2987 1.3709A3.4852 3.4852 0 0 0 7.5 13C5.567 13 4 14.567 4 16.5S5.567 20 7.5 20s3.5-1.567 3.5-3.5a3.4851 3.4851 0 0 0-.3728-1.5735l1.3214-1.2585L17 19h3v-1l-6.3-6L20 6V5h-3l-5.0514 5.332-1.3214-1.2585zM7.5 9C8.3284 9 9 8.3284 9 7.5S8.3284 6 7.5 6 6 6.6716 6 7.5 6.6716 9 7.5 9zm0 6c.8284 0 1.5.6716 1.5 1.5S8.3284 18 7.5 18 6 17.3284 6 16.5 6.6716 15 7.5 15z"
  })];
};

exports.default = _default;